import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CardErrorSummary } from '../../../../../../utils/models/common.interface';

@Component({
  selector: 'card-error-summary-induxtry',
  templateUrl: './card-error-summary.component.html',
  styleUrls: ['./card-error-summary.component.scss']
})
export class CardErrorSummaryComponent {
  @Input() cardErrorSummary: CardErrorSummary;
  @Output() clickedCard: EventEmitter<CardErrorSummary> = new EventEmitter();

  handleClickCardErrorSummary(): void {
    this.clickedCard.emit(this.cardErrorSummary);
  }
}
